import { render } from "./SceneCard.vue?vue&type=template&id=1db4c169&ts=true"
import script from "./SceneCard.vue?vue&type=script&lang=ts"
export * from "./SceneCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__